import api from './api';

export const modelImportService = {
  // Download template
  downloadTemplate: async (workspaceId: string, format: 'xlsx' | 'csv' = 'xlsx'): Promise<Blob> => {
    const response = await api.get(`/workspaces/${workspaceId}/models/import/template`, {
      params: { format },
      responseType: 'blob'
    });
    return response.data;
  },

  // Parse uploaded file
  parseFile: async (workspaceId: string, file: File): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/workspaces/${workspaceId}/models/import/parse`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Bulk create models
  bulkCreate: async (workspaceId: string, projectId: string, builderId: string, rows: any[]): Promise<any> => {
    const response = await api.post(`/workspaces/${workspaceId}/models/import/bulk-create`, {
      projectId,
      builderId,
      rows
    });
    return response.data;
  }
};
